import BSJA6BDOffLineModal from './BSJ_A6BD_off_line-modal.vue'
export default BSJA6BDOffLineModal
